var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon03SettlementMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C3.44772 2 3 2.44772 3 3V9V13V17V21C3 21.5523 3.44772 22 4 22H9H15H20C20.5523 22 21 21.5523 21 21V17V13V9V3C21 2.44772 20.5523 2 20 2H4ZM19 16V14H16V16H19ZM16 18H19V20H16V18ZM14 16V14H10V16H14ZM10 18H14V20H10V18ZM8 16V14H5V16H8ZM5 18H8V20H5V18ZM5 12H8V10H5V12ZM10 12H14V10H10V12ZM16 12H19V10H16V12ZM15 8H19V4H5V8H9H15Z",
    fill: "#46B476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03SettlementMeta);
export default __webpack_public_path__ + "static/media/icon03_settlementMeta.e71422ec8ac572d29ad79b6acd7cefb8.svg";
export { ForwardRef as ReactComponent };